<template>
  <div id="demonstration"
       v-if="menuList.indexOf(220010)>-1">
    <!-- <header class="board-header">
      数据中心
    </header> -->
    <div id="BaseInfo"
         class="board-ctx">
      <div class="ctx-card"
           v-for="(e,i) in baseInfoList"
           :key="i">
        <div class="card-box">
          <img class="pic"
               :src="e.type" />
          <div class="txt">{{e.name}}</div>
          <div class="number">{{e.number}}</div>
        </div>
      </div>
    </div>
    <div class="board-echarts">
      <div class="echarts-items echarts-pie">
        <div class="items-card">
          <div class="card-title">
            当日收费汇总
          </div>
          <div class="card-txt">
            <div class="txt-rs">
              <div id="SummaryOfCharges"
                   class="rs-ctx">
                <div class="ctx-cell"
                     v-for="(e,i) in payAmount"
                     :key="i"><span>{{e.fPayTypeName}}:</span>
                  <span class="number">{{e.fAmount}}</span>
                </div>
              </div>
              <div class="rs-total">
                <span>总收入:</span>
                <span id="totalIn"
                      class="number">{{totalAmount}}</span>
              </div>
            </div>
            <div class="txt-pie">
              <!-- <div class="pie-income">
                <span id="InCome"></span>
                <span class="unit">%</span>
              </div>
              <div class="pie-exp">
                <span id="ExpCome"></span>
                <span class="unit">%</span>
              </div> -->
              <div id="FeePie"
                   class="pie"></div>
            </div>

          </div>
        </div>
      </div>
      <div class="echarts-items echarts-line">
        <div class="items-card">
          <div class="card-title">
            当日进出场车辆统计
          </div>
          <div class="card-txt">
            <div class="txt-list">
              <div class="txt">在场车辆数</div>
              <div class="txt leave">离场车辆数</div>
              <div class="txt entry">入场车辆数</div>
            </div>
            <div id="CarEcharts"
                 class="txt-line">

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="board-footer">
      <div class="footer-item">
        <div class="item-rs">
          <div class="card-title">
            月租车
          </div>
          <div class="rs-type">
            <div class="type-ctx">
              <div class="ctx-cell"
                   v-for="(e,i) in cardTypeNum"
                   :key="i">
                <span>{{e.fCardTypeName}}:</span>
                <span class="number">{{e.fNum}}</span>
              </div>
            </div>
            <div class="type-total">
              <span>总数量:</span>
              <span class="number">{{totalNum}}</span>
            </div>
          </div>
          <div class="rs-echarts">
            <div class="echarts-list">

              <div :class="'txt '+ e.fColor"
                   v-for="(e,i) in cardTypeNum"
                   :key="i">{{e.fCardTypeName}}</div>

            </div>
            <div id="MonthCard"
                 class="echarts-pie">

            </div>
          </div>
        </div>
      </div>
      <div class="footer-item">
        <div class="item-rs">
          <div class="card-title">
            优惠券
          </div>
          <div class="rs-type">
            <div class="type-ctx">
              <div class="ctx-cell">
                <span>已使用:</span>
                <span class="number">{{coupon.used_count}}</span>
              </div>
              <div class="ctx-cell">
                <span>未使用:</span>
                <span class="number">{{coupon.gotten_count}}</span>
              </div>
              <div class="ctx-cell">
                <span>已过期:</span>
                <span class="number">{{coupon.expired_count}}</span>
              </div>
              <div class="ctx-cell">
                <span>未领用:</span>
                <span class="number">{{coupon.not_gotten_count}}</span>
              </div>
            </div>
            <div class="type-total">
              <span>总数量:</span>
              <span class="number">{{coupon.all_count}}</span>
            </div>
          </div>
          <div class="rs-echarts">
            <div class="echarts-list">
              <div class="txt">已使用</div>
              <div class="txt red">未使用</div>
              <div class="txt green">已过期</div>
              <div class="txt yellow">未领用</div>
            </div>
            <div id="discountChart"
                 class="echarts-pie">

            </div>
          </div>
        </div>
      </div>
      <div class="footer-item">
        <div class="item-rs">
          <div class="card-title">
            设备信息
          </div>
          <ul id="DeviceInfo"
              class="rs-list">
            <li class="list-cell title">
              <div class="name">编号</div>
              <div class="name">名称</div>
              <div class="name">状态</div>
              <div class="ip">IP地址</div>
            </li>
            <li class="list-cell"
                v-for="(e,i) in equList"
                :key="i">
              <div class="name">{{e.num}}</div>
              <div class="name">{{e.fEquType}}</div>
              <div class="name">{{e.fStatus}}</div>
              <div class="ip">{{e.fEquIP}}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <el-row v-else>
    <el-col style="text-align:center">
      <i class="web-font">欢迎来到停车云平台管理系统</i>
    </el-col>
  </el-row>
</template>
<script>
import { statistics as api } from '../../api/statistics'
// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/line')
// 引入饼状图
require('echarts/lib/chart/pie')
// 引入提示框和标题组件
require('echarts/components')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/grid')
require('echarts/lib/coord/cartesian/Grid')
require('echarts/lib/coord/cartesian/Axis2D')
require('echarts/lib/component/title')
require('echarts/lib/component/graphic')
export default {
  data () {
    return {
      totalAmount: 0,
      payAmount: [],
      cardTypeNum: [],
      equList: [],
      totalNum: 0,
      coupon: {},
      baseInfoList: [{
        'type': require('@/assets/images/LeiJiShouRu.png'),
        'name': '当月累计收入',
        'number': 0
      }, {
        'type': require('@/assets/images/ZaiChangeCar.png'),
        'name': '在场车辆',
        'number': 0
      }, {
        'type': require('@/assets/images/MonthCar.png'),
        'name': '月卡车',
        'number': 0
      }, {
        'type': require('@/assets/images/DeviceTotal.png'),
        'name': '设备总量',
        'number': 0
      }, {
        'type': require('@/assets/images/DiscountNumber.png'),
        'name': '优惠券发放量',
        'number': 0
      }]
    }
  },
  props: {
    menuList: { type: Array, required: true }
  },
  methods: {
    setAmountPie (data) {
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: [{
          name: '支付方式',
          type: 'pie',
          center: ['50%', '50%'],
          label: {
            show: false,
            position: 'center'
          },
          data: data
        }]
      }
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('FeePie'))
      myChart.setOption(option)
    },
    setVehicleInAndOut (entryCar, leaveCar, spotCar) {
      var carCharts = echarts.init(document.getElementById('CarEcharts'))
      var carOptions = {
        color: ['#3384d2', '#39d444', '#f59834'],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: true
          },
          axisLine: {
            lineStyle: {
              color: '#999999',
              type: 'dashed'
            }
          },
          data: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
        },
        yAxis: {
          axisTick: {
            show: true
          },
          axisLabel: {
            show: true
          },
          axisLine: {
            lineStyle: {
              color: '#999999',
              type: 'dashed'
            }
          },
          type: 'value'
        },
        series: [{
          symbol: 'none', // 去掉折线图中的节点
          smooth: true,
          name: '在场车辆',
          type: 'line',
          data: spotCar
        },
        {
          symbol: 'none', // 去掉折线图中的节点
          smooth: true,
          name: '离场车辆',
          type: 'line',
          data: leaveCar
        },
        {
          symbol: 'none', // 去掉折线图中的节点
          smooth: true,
          name: '入场车辆',
          type: 'line',
          data: entryCar
        }]
      }
      carCharts.setOption(carOptions)
    },
    setCardTypeAmountPie (data) {
      // 月卡
      var monthChart = echarts.init(document.getElementById('MonthCard'))
      var monthOptions = {
        color: ['#3384d2', '#f22e3a', '#38d36f', '#ffb507', '#ff9800'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}'
        },
        graphic: [{ // 图形中间文字
          type: 'text',
          left: 'center',
          top: '35%',
          style: {
            text: '总数量',
            textAlign: 'center',
            fill: '#2c2c2c',
            fontSize: 16
          }
        }, { // 图形中间文字
          type: 'text',
          left: 'center',
          top: '45%',
          style: {
            text: this.totalNum,
            textAlign: 'center',
            fill: '#fd6326',
            fontSize: 26
          }
        }],
        series: [
          {
            name: '月卡分类',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['50%', '50%'],
            data: data,
            label: {
              color: '#fff',
              show: false,
              position: 'inside',
              formatter: '{b}',
              fontSize: 16
            },
            labelLine: {
              show: false
            }
          }
        ]
      }
      monthChart.setOption(monthOptions)
    },
    setCouponPie (data) {
      // 优惠券
      var discountChart = echarts.init(document.getElementById('discountChart'))
      var discountOptions = {
        color: ['#3384d2', '#38d36f', '#f22e3a', '#ffb507', '#ff9800'],
        tooltip: {
          trigger: 'item',
          formatter: '{b}  ({d}%)'
        },
        graphic: [{ // 图形中间文字
          type: 'text',
          left: 'center',
          top: '35%',
          style: {
            text: '总数量',
            textAlign: 'center',
            fill: '#2c2c2c',
            fontSize: 16
          }
        }, { // 图形中间文字
          type: 'text',
          left: 'center',
          top: '45%',
          style: {
            text: this.coupon.all_count,
            textAlign: 'center',
            fill: '#fd6326',
            fontSize: 40
          }
        }],
        series: [
          {
            name: '优惠券使用数量',
            type: 'pie',
            radius: ['65%', '70%'],
            center: ['50%', '50%'],
            data: data,
            label: {
              color: '#fff',
              show: false,
              position: 'inside',
              formatter: '{b}({d}%)',
              fontSize: 16
            },
            labelLine: {
              show: false
            }
          }
        ]
      }
      discountChart.setOption(discountOptions)
    }
  },
  created () {

  },
  mounted () {
    api.getBasicStatisticalData().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.baseInfoList[0].number = data.Data.payAmountCount
          this.baseInfoList[1].number = data.Data.carPresentCount
          this.baseInfoList[2].number = data.Data.cardBaseCount
          this.baseInfoList[3].number = data.Data.custEquCount
          this.baseInfoList[4].number = data.Data.couponBatchCount
        }
      }
    })
    api.getPayTypeAmountData().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.payAmount = data.Data.items || []
          this.totalAmount = data.Data.totalAmount || 0
          var dataPie = []
          for (let i = 0; i < this.payAmount.length; i++) {
            dataPie.push({ value: this.payAmount[i].fAmount, name: this.payAmount[i].fPayTypeName })
          }
          this.setAmountPie(dataPie)
        }
      }
    })
    api.getVehicleInAndOutData().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.setVehicleInAndOut(data.Data.apo_data_list || [], data.Data.his_data_list || [], data.Data.cur_data_list || [])
        }
      }
    })
    api.getMonthlyCardData().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.cardTypeNum = data.Data.items || []
          this.totalNum = data.Data.totalNum
          var pie = []
          for (let i = 0; i < this.cardTypeNum.length; i++) {
            pie.push({ value: this.cardTypeNum[i]['fNum'], name: this.cardTypeNum[i]['fCardTypeName'] })
          }
          this.setCardTypeAmountPie(pie)
        }
      }
    })

    api.getEquList().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.equList = data.Data || []
        }
      }
    })
    api.getCouponBatchDetailCount().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.coupon = data.Data
          var pie = []
          pie.push({ name: '已使用', value: this.coupon.used_count })
          pie.push({ name: '未使用', value: this.coupon.gotten_count })
          pie.push({ name: '已过期', value: this.coupon.expired_count })
          pie.push({ name: '未领用', value: this.coupon.not_gotten_count })
          this.setCouponPie(pie)
        }
      }
    })
  },
  updated () {

  }
}
</script>
<style scoped>
@import url("../../../static/font/font");
.web-font {
  font-size: 40px;
}
#demonstration {
  background: #dbdae4;
  min-width: 1200px;
}
.board-header {
  width: 100%;
  height: 2.3rem;
  line-height: 2.3rem;
  background: #fff;
  padding: 0 1rem;
  box-sizing: border-box;
  font-size: 1.24rem;
  color: #2c2c2c;
}
.board-ctx {
  width: 100%;
  background: #dbdae4;
  font-size: 0;
  padding: 1rem 0.5rem;
  box-sizing: border-box;
}

.board-ctx > .ctx-card {
  display: inline-block;
  vertical-align: middle;
  width: 20%;
  padding: 0 0.5rem;
  box-sizing: border-box;
}
.board-ctx > .ctx-card > .card-box {
  width: 100%;
  position: relative;
  box-shadow: 0 0 6px 2px rgba(138, 138, 138, 0.5);
}
.board-ctx > .ctx-card > .card-box > .pic {
  width: 100%;
  height: auto;
}

.board-ctx > .ctx-card > .card-box > .txt {
  position: absolute;
  top: 0.7rem;
  right: 1rem;
  color: #fff;
  font-size: 1rem;
}

.board-ctx > .ctx-card > .card-box > .number {
  position: absolute;
  bottom: 1.5rem;
  right: 1rem;
  color: #fff;
  font-size: 1.5rem;
}

.board-echarts {
  width: 100%;
  padding: 0 1rem;
  box-sizing: border-box;
  font-size: 0;
}
.board-echarts > .echarts-items {
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  width: 50%;
}

.board-echarts > .echarts-items.echarts-pie {
  padding-right: 0.5rem;
}
.board-echarts > .echarts-items.echarts-line {
  padding-left: 0.5rem;
}
.board-echarts > .echarts-items > .items-card {
  background: #fff;
  height: 20rem;
}

.card-title {
  width: 100%;
  height: 2.1rem;
  padding: 0 1.4rem;
  box-sizing: border-box;
  font-size: 0.85rem;
  color: #2c2c2c;
  position: relative;
  line-height: 2.1rem;
}

.card-title:after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0.5rem;
  width: 8px;
  height: 8px;
  background: #3384d2;
  border-radius: 2px;
}

.board-echarts > .echarts-items > .items-card > .card-txt {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.board-echarts > .echarts-items > .items-card > .card-txt > .txt-rs {
  width: calc(100% - 19rem);
  /* height: 6.5rem; */
  padding: 0rem 1.3rem;
  box-sizing: border-box;
}

.board-echarts > .echarts-items > .items-card > .card-txt > .txt-rs > .rs-ctx {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-rs
  > .rs-ctx
  > .ctx-cell {
  margin-right: 1rem;
  font-size: 0.85rem;
  color: #2c2c2c;
  font-weight: 500;
  box-sizing: border-box;
  margin-bottom: 1rem;
}

/* .board-echarts>.echarts-items>.items-card>.card-txt>.txt-rs>.rs-ctx>.ctx-cell:not(:nth-of-type(4n+1)){
   margin-left:2rem;
} */
.board-echarts > .echarts-items > .items-card > .card-txt > .txt-rs {
  margin: 0 1.3rem;
  padding: 0;
}
.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-rs
  > .rs-ctx
  > .ctx-cell
  > .number {
  color: #fd7227;
}

.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-rs
  > .rs-total {
  width: 100%;
  font-size: 0.85rem;
  color: #2c2c2c;
  font-weight: 500;
  box-sizing: border-box;
  margin-bottom: 1.9rem;
}
.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-rs
  > .rs-total
  > .number {
  color: #fd7227;
}
.board-echarts > .echarts-items > .items-card > .card-txt > .txt-pie {
  width: 18rem;
  height: 18rem;
  position: relative;
}

.board-echarts > .echarts-items > .items-card > .card-txt > .txt-pie > .pie {
  position: absolute;
  width: 100%;
  height: 100%;
}

.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-pie
  > .pie-income {
  position: absolute;
  top: 30px;
  right: 0;
  color: #807e7e;
  font-size: 2.5rem;
}
.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-pie
  > .pie-income
  > .unit {
  font-size: 0.8rem;
  color: #807e7e;
  margin-left: -0.5rem;
}
.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-pie
  > .pie-exp {
  position: absolute;
  bottom: 30px;
  left: 0;
  color: #807e7e;
  font-size: 2.5rem;
}
.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-pie
  > .pie-exp
  > .unit {
  font-size: 0.8rem;
  color: #807e7e;
  margin-left: -0.5rem;
}

.board-echarts > .echarts-items > .items-card > .card-txt > .txt-list {
  width: 7rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 1rem;
  box-sizing: border-box;
}

.board-echarts > .echarts-items > .items-card > .card-txt > .txt-list > .txt {
  font-size: 0.85rem;
  color: #2c2c2c;
  padding-left: 1rem;
  box-sizing: border-box;
  position: relative;
}
.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-list
  > .txt:after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background: #3384d2;
  left: 0;
}
.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-list
  > .txt.leave:after {
  background: #39d444;
}
.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-list
  > .txt.entry:after {
  background: #f59834;
}

.board-echarts
  > .echarts-items
  > .items-card
  > .card-txt
  > .txt-list
  > .txt:nth-of-type(2) {
  margin: 2rem 0;
}

.board-echarts > .echarts-items > .items-card > .card-txt > .txt-line {
  width: calc(100% - 10rem);
  height: 16rem;
}

/* 底部 */
.board-footer {
  width: 100%;
  margin-top: 1rem;
  padding: 0 1rem 1rem 1rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.board-footer > .footer-item {
  flex: 1;
  height: 25.25rem;
  box-sizing: border-box;
}

.board-footer > .footer-item:first-child {
  padding-right: 0.5rem;
  box-sizing: border-box;
}
.board-footer > .footer-item:nth-of-type(2) {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  box-sizing: border-box;
}
.board-footer > .footer-item:last-child {
  padding-left: 0.5rem;
  box-sizing: border-box;
}

.board-footer > .footer-item > .item-rs {
  width: 100%;
  height: 100%;
  background: #fff;
}

.board-footer > .footer-item .rs-type {
  width: 100%;
}
.board-footer > .footer-item .rs-type > .type-ctx {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  padding-left: 1.3rem;
  box-sizing: border-box;
}

.board-footer > .footer-item .rs-type > .type-ctx > .ctx-cell {
  margin-right: 1rem;
  margin-bottom: 0.6rem;
  font-size: 0.85rem;
  color: #2c2c2c;
  font-weight: 500;
  box-sizing: border-box;
}
.board-footer > .footer-item .rs-type > .type-ctx > .ctx-cell > .number {
  color: #fd7227;
}

.board-footer > .footer-item .type-total {
  width: 100%;
  padding-left: 1.3rem;
  box-sizing: border-box;
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: #2c2c2c;
  font-weight: 500;
}
.board-footer > .footer-item .type-total > .number {
  color: #fd7227;
}

.board-footer > .footer-item .rs-echarts {
  width: 100%;
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding-left: 4rem; */
  box-sizing: border-box;
}

.board-footer > .footer-item .rs-echarts > .echarts-list {
  margin-right: 3rem;
}
.board-footer > .footer-item .rs-echarts > .echarts-list > .txt {
  padding-left: 1.5rem;
  box-sizing: border-box;
  font-size: 0.85rem;
  color: #2c2c2c;
  position: relative;
}
.board-footer > .footer-item .rs-echarts > .echarts-list > .txt:after {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background: #3384d2;
  left: 0;
}
.board-footer
  > .footer-item
  .rs-echarts
  > .echarts-list
  > .txt:not(:last-child) {
  margin-bottom: 1.5rem;
}

.board-footer > .footer-item .rs-echarts > .echarts-list > .txt.green:after {
  background: #38d36f;
}

.board-footer > .footer-item .rs-echarts > .echarts-list > .txt.red:after {
  background: #f22e3a;
}

.board-footer > .footer-item .rs-echarts > .echarts-list > .txt.yellow:after {
  background: #ffb507;
}

.board-footer > .footer-item .rs-echarts > .echarts-list > .txt.blue:after {
  background: #0d34b7;
}
.board-footer > .footer-item .rs-echarts > .echarts-list > .txt.pink:after {
  background: #d0919c;
}
.board-footer > .footer-item .rs-echarts > .echarts-pie {
  width: 12.25rem;
  height: 12.25rem;
}

.board-footer > .footer-item > .item-rs > .rs-list {
  width: 100%;
  height: calc(100% - 2.1rem);
  overflow-y: auto;
  margin: 0;
  padding: 0;
}

.board-footer > .footer-item > .item-rs > .rs-list > .list-cell {
  width: 100%;
  height: 2.5rem;
  border-bottom: 1px solid #e5e5e5;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.board-footer > .footer-item > .item-rs > .rs-list > .list-cell.title > .name {
  flex: 1;
  text-align: center;
  color: #2c2c2c;
  font-weight: bold;
  font-size: 0.85rem;
}
.board-footer > .footer-item > .item-rs > .rs-list > .list-cell.title > .ip {
  flex: 1.5;
  text-align: center;
  color: #2c2c2c;
  font-weight: bold;
  font-size: 0.85rem;
}
.board-footer > .footer-item > .item-rs > .rs-list > .list-cell > .name {
  flex: 1;
  text-align: center;
  color: #2c2c2c;
  font-size: 0.85rem;
}
.board-footer > .footer-item > .item-rs > .rs-list > .list-cell > .ip {
  flex: 1.5;
  text-align: center;
  color: #2c2c2c;
  font-size: 0.85rem;
}
</style>



// WEBPACK FOOTER //
// src/view/home/demonstration.vue